import * as typography from './typography';

export const mixins = {
    typography,
};
